/* eslint-disable @typescript-eslint/no-explicit-any */
export class Param {
  private constructor(
    public code: string = '',
    public type: string = '',
    public value: string = ''
  ) {}

  static create(item: Record<string, string> = {}): Param {
    return new Param(
      item.code,
      item.type,
      item.value
    );
  }

  static createMap(items: Record<string, any>[] = []): Param[] {
    return items.map((item) => {
        return Param.create(item);
    });
  }
}
